import { Link } from "react-router-dom";

export default function Privacy() {
  const updated = "December 2025";
  return (
    <>
      <section className="bg-[#0A1128] py-20 text-white sm:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E8772E]">Legal</p>
          <h1 className="mt-4 font-serif-display text-4xl font-medium leading-tight sm:text-5xl">Privacy Policy</h1>
          <p className="mt-3 text-sm text-white/60">Last updated: {updated}</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <article className="prose-style space-y-8 text-[#334155]">
            <Block title="1. Who we are">
              <p>
                This website is operated by <strong>PrimeCore Solutions Pvt. Ltd.</strong> (registered in Sri Lanka and Bangladesh) ("PrimeCore", "we", "us"). We provide Q-Wis, a Windows-based smart quality and process governance solution for apparel manufacturing. If you have any questions about this policy, contact us at <a className="text-[#E8772E] hover:underline" href="mailto:info@pcoresolution.com">info@pcoresolution.com</a>.
              </p>
            </Block>

            <Block title="2. Information we collect">
              <p>We only collect what you voluntarily provide:</p>
              <ul className="ml-5 list-disc space-y-2">
                <li><strong>Contact form:</strong> name, email, optional company, optional phone, your message.</li>
                <li><strong>Demo request form:</strong> name, email, company, country, role/title, modules of interest, optional message.</li>
                <li><strong>Admin sign-in (PrimeCore staff only):</strong> Google account name, email, profile picture and a session token, via Google's OAuth.</li>
                <li><strong>Basic technical data:</strong> the website may use standard browser/server logs and product analytics for security and to improve the site.</li>
              </ul>
            </Block>

            <Block title="3. Why we use your information">
              <ul className="ml-5 list-disc space-y-2">
                <li>To respond to your inquiry or schedule the demo you requested.</li>
                <li>To send you a tailored pricing or implementation proposal for Q-Wis.</li>
                <li>To follow up about Q-Wis if you have expressed interest.</li>
                <li>To operate, secure and improve the website.</li>
                <li>To meet our legal obligations.</li>
              </ul>
              <p>We do not sell your data, and we do not share it for third-party advertising.</p>
            </Block>

            <Block title="4. How long we keep it">
              <p>We retain inquiries and demo requests for as long as needed to follow up with you and for our internal records, after which they are deleted on request. You can ask us to delete your data at any time by emailing <a className="text-[#E8772E] hover:underline" href="mailto:info@pcoresolution.com">info@pcoresolution.com</a>.</p>
            </Block>

            <Block title="5. Who can see your information">
              <p>Lead inquiries are accessible only to authorised PrimeCore administrators, signed in via Google with two-factor protection on their Google account. We use trusted infrastructure providers (database hosting, email delivery) to operate the service; they only process data on our behalf.</p>
            </Block>

            <Block title="6. International transfers">
              <p>PrimeCore operates from Sri Lanka and Bangladesh and may store and process your data on servers in those or other countries. By contacting us, you consent to this transfer.</p>
            </Block>

            <Block title="7. Your rights">
              <p>Subject to applicable law, you have the right to access, correct, or delete the personal data we hold about you, and to withdraw consent. Email <a className="text-[#E8772E] hover:underline" href="mailto:info@pcoresolution.com">info@pcoresolution.com</a> and we will respond within a reasonable timeframe.</p>
            </Block>

            <Block title="8. Cookies">
              <p>The website uses essential cookies only (e.g. an admin session cookie when a PrimeCore administrator signs in). It does not set advertising or third-party tracking cookies.</p>
            </Block>

            <Block title="9. Security">
              <p>We use reasonable technical and organisational safeguards (encrypted connections, restricted admin access, allow-listed Google sign-in for staff) to protect your data. No method of transmission over the internet is 100% secure, however.</p>
            </Block>

            <Block title="10. Changes to this policy">
              <p>We may update this Privacy Policy from time to time. We will revise the "Last updated" date above whenever we do.</p>
            </Block>

            <Block title="11. Contact">
              <p>PrimeCore Solutions Pvt. Ltd.<br />Email: <a className="text-[#E8772E] hover:underline" href="mailto:info@pcoresolution.com">info@pcoresolution.com</a><br />Registered in Sri Lanka and Bangladesh.</p>
            </Block>

            <p className="text-sm text-[#64748B]">See also our <Link className="text-[#0A1128] underline hover:text-[#E8772E]" to="/terms">Terms of Service</Link>.</p>
          </article>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-2xl text-[#0A1128]">{title}</h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed text-[#334155]">{children}</div>
    </section>
  );
}
